export const normalizeAvatar = (src) => {
  if (typeof src !== 'string') return null;

  const value = src.trim();
  if (!value || value === 'null' || value === 'undefined') return null;

  return value;
};

export const hasAvatarUrl = (src) => Boolean(normalizeAvatar(src));
